import Constants from "@/utils/constants";
import Fetch from "@/utils/Fetch";

const getDocumentDefinition = async () => {
    const documentDefinition = await Fetch.get({
        url: "/DocumentDefinition",
    });

    return documentDefinition;
};

const getUseLegacyDocuments = async () => {
    let optionValue = await Fetch.get({
        url: `/Option/GetByOptionName?name=${Constants.optionKeys.LegacyDocuments}`,
      });

    optionValue = typeof optionValue === 'string' && optionValue.toLowerCase().trim() === "true";
    return optionValue;
  }


export default {
    getDocumentDefinition,
    getUseLegacyDocuments
};